import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';
import type { ICustomSearchScenario } from '@/api/cms/searchScenario';
import { getCustomSearchScenariosUrl } from '@/api/cms/searchScenario';
import { fetcherCMS } from '@/modules/api';
import { findCustomSearchScenario } from '../components/SearchFallbackScenarios/helpers';

export const useCustomSearchScenario = (searchPhrase: string) => {
  const url = useMemo(() => getCustomSearchScenariosUrl(), []);

  const { data = null, isLoading } = useSWRImmutable<ICustomSearchScenario[]>(
    url,
    fetcherCMS
  );

  const scenario = useMemo(
    () => findCustomSearchScenario(data ?? [], searchPhrase),
    [data, searchPhrase]
  );

  return { scenario, isLoading };
};
